import * as Yup from 'yup'

export const ContactValidSchema = Yup.object().shape({
  type: Yup.string().required('Insira o tipo.'),
  phone: Yup.string()
    .required('Insira um número de telefone.')
    .test('phone-validation', function (value) {
      const phoneCode = String(this.parent?.phoneCode ?? '')
        .replace(/\D/g, '')
        .replace(/^0+/, '')

      if (!value) {
        return this.createError({
          message: 'Insira um número de telefone.',
        })
      }

      // Brasil
      if (phoneCode === '55' || phoneCode === '0055') {
        const numbers = value.replace(/\D/g, '')
        if (numbers.length < 10 || numbers.length > 11) {
          return this.createError({
            message:
              'Insira um número de telefone válido no formato (XX) XXXX-XXXX ou (XX) XXXXX-XXXX.',
          })
        }

        return true
      }

      // Outros países
      const numbers = value.replace(/\D/g, '')

      if (numbers.length < 7 || numbers.length > 17) {
        return this.createError({
          message: 'O telefone deve possuir entre 7 e 17 números.',
        })
      }

      return true
    }),
})
